import en from "./en.json";
import de from "./de.json";
import fr from "./fr.json";
import es from "./es.json";
import ar from "./ar.json";

export type Language = "en" | "de" | "fr" | "es" | "ar";

export const translations: Record<Language, Record<string, string>> = {
  en,
  de,
  fr,
  es,
  ar,
};

export const languageNames: Record<Language, { name: string; flag: string; nativeName: string }> = {
  en: { name: "English", flag: "🇺🇸", nativeName: "English" },
  de: { name: "German", flag: "🇩🇪", nativeName: "Deutsch" },
  fr: { name: "French", flag: "🇫🇷", nativeName: "Français" },
  es: { name: "Spanish", flag: "🇪🇸", nativeName: "Español" },
  ar: { name: "Arabic", flag: "🇶🇦", nativeName: "العربية" },
};

export const rtlLanguages: Language[] = ["ar"];

export const isRTL = (language: Language): boolean => {
  return rtlLanguages.includes(language);
};
